import fetchManager from '@utils/fetchManager'
import { urlQueryData, getEnvironment } from '@utils/general'

const API_URL = getEnvironment("API_DOMAIN");

  export default {
    getAdministrators: async () => {
      const errorModal = { show: 'no' }
      const response = await fetchManager(`${API_URL}/IdentityManagement/api/amx/cpe/users/administrators`, {}, errorModal)
      return  response
    },
    deleteAdmin: async (email, data) => {
      const response = await fetchManager(`${API_URL}/IdentityManagement/api/amx/cpe/users/administrators/${email}`, {
          method: 'DELETE',
          data,
        })
      return response
    },
    assignAdmin: async (data) => {
      const response = await fetchManager(`${API_URL}/IdentityManagement/api/amx/cpe/users/administrators`, {
          method: 'POST',
          data,
        })
      return response
    },
    editAdmin: async (data) => {
      const response = await fetchManager(`${API_URL}/IdentityManagement/api/amx/cpe/users/administrators`, {
          method: 'PUT',
          data,
        })
      return response
    },
  }